/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Stats_Itemstooltip1Inputs */

const id_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item adalah hak untuk peluncur`)
};

const ms_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item ialah hak untuk pelancar`)
};

const da_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et item er rettigheden til launcher'en`)
};

const de_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Item ist die Berechtigung für den Launcher`)
};

const en_us2_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An item is the entitlement for the launcher`)
};

const es_es2_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un item es el entitlement para el launcher`)
};

const es_mx2_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un ítem es el derecho para el launcher`)
};

const fil_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang item ay ang entitlement para sa launcher`)
};

const fr_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un item est le droit (entitlement) pour le launcher`)
};

const it_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un articolo è il diritto per il launcher`)
};

const hu_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az elem a jogosultság a launcherhez`)
};

const nl_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een item is het recht voor de launcher`)
};

const no_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et element er rettigheten for launcher`)
};

const pl_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element to uprawnienie do uruchamiania w launcherze`)
};

const pt_br2_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items tooltip`)
};

const pt_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um item é o direito de utilização para o launcher`)
};

const ro_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un element este dreptul pentru launcher`)
};

const fi_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohde on oikeus launcherille`)
};

const sv_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ett objekt är rättigheten för launchern`)
};

const vi_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một mục là quyền cho launcher`)
};

const tr_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğe, başlatıcı için yetkilendirmedir`)
};

const cs_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položka je oprávnění pro launcher`)
};

const bg_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обектът е право за лаунчъра`)
};

const ru_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объект — это отдельный объект для лаунчера`)
};

const uk_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Елемент — це право (entitlement) для лаунчера`)
};

const ar_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العنصر هو الحق (entitlement) للمشغل`)
};

const hi_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइटम लॉन्चर के लिए एंटाइटलमेंट है`)
};

const th_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการคือสิทธิ์ (entitlement) สำหรับ launcher`)
};

const ja_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテムはランチャーのエンタイトルメントです`)
};

const zh_cn2_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items tooltip`)
};

const zh_hant1_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items tooltip`)
};

const ko_components_stats_itemstooltip1 = /** @type {(inputs: Components_Stats_Itemstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items tooltip`)
};

/**
* | output |
* | --- |
* | "An item is the entitlement for the launcher" |
*
* @param {Components_Stats_Itemstooltip1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_stats_itemstooltip1 = /** @type {((inputs?: Components_Stats_Itemstooltip1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Stats_Itemstooltip1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_stats_itemstooltip1(inputs)
	if (locale === "ms") return ms_components_stats_itemstooltip1(inputs)
	if (locale === "da") return da_components_stats_itemstooltip1(inputs)
	if (locale === "de") return de_components_stats_itemstooltip1(inputs)
	if (locale === "en-US") return en_us2_components_stats_itemstooltip1(inputs)
	if (locale === "es-ES") return es_es2_components_stats_itemstooltip1(inputs)
	if (locale === "es-MX") return es_mx2_components_stats_itemstooltip1(inputs)
	if (locale === "fil") return fil_components_stats_itemstooltip1(inputs)
	if (locale === "fr") return fr_components_stats_itemstooltip1(inputs)
	if (locale === "it") return it_components_stats_itemstooltip1(inputs)
	if (locale === "hu") return hu_components_stats_itemstooltip1(inputs)
	if (locale === "nl") return nl_components_stats_itemstooltip1(inputs)
	if (locale === "no") return no_components_stats_itemstooltip1(inputs)
	if (locale === "pl") return pl_components_stats_itemstooltip1(inputs)
	if (locale === "pt-BR") return pt_br2_components_stats_itemstooltip1(inputs)
	if (locale === "pt") return pt_components_stats_itemstooltip1(inputs)
	if (locale === "ro") return ro_components_stats_itemstooltip1(inputs)
	if (locale === "fi") return fi_components_stats_itemstooltip1(inputs)
	if (locale === "sv") return sv_components_stats_itemstooltip1(inputs)
	if (locale === "vi") return vi_components_stats_itemstooltip1(inputs)
	if (locale === "tr") return tr_components_stats_itemstooltip1(inputs)
	if (locale === "cs") return cs_components_stats_itemstooltip1(inputs)
	if (locale === "bg") return bg_components_stats_itemstooltip1(inputs)
	if (locale === "ru") return ru_components_stats_itemstooltip1(inputs)
	if (locale === "uk") return uk_components_stats_itemstooltip1(inputs)
	if (locale === "ar") return ar_components_stats_itemstooltip1(inputs)
	if (locale === "hi") return hi_components_stats_itemstooltip1(inputs)
	if (locale === "th") return th_components_stats_itemstooltip1(inputs)
	if (locale === "ja") return ja_components_stats_itemstooltip1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_stats_itemstooltip1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_stats_itemstooltip1(inputs)
	return ko_components_stats_itemstooltip1(inputs)
});
export { components_stats_itemstooltip1 as "components.stats.itemsTooltip" }